import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

const Column = ({
  up = false,
  right = false,
  down = false,
  left = false,
  children,
  className = "",
  ...restProps
}: {
  up?: boolean;
  right?: boolean;
  down?: boolean;
  left?: boolean;
  children: ReactNode;
  className?: string;
  [x: string]: any;
}) => (
  <div
    className={twMerge(
      !up && !right && !down && !left && "column",
      up && !right && !down && !left && "column-up",
      !up && right && !down && !left && "column-right",
      !up && !right && down && !left && "column-down",
      !up && !right && !down && left && "column-left",
      up && right && !down && !left && "column-up-right",
      up && !right && !down && left && "column-up-left",
      !up && right && down && !left && "column-down-right",
      !up && !right && down && left && "column-down-left",
      className,
    )}
    {...restProps}
  >
    {children}
  </div>
);

export default Column;
